import type { InferOutput } from 'valibot'
import { object, optional, pipe, string, transform } from 'valibot'

// This is missing a lot of fields which we currently don't use.
export const podcastRssFeedSchema = object({
  title: string(),
  description: string(),
  image: pipe(
    object({
      url: string(),
    }),
    transform(it => it.url),
  ),
  items: pipe(
    safeArray(
      pipe(
        object({
          guid: string(),
          title: string(),
          isoDate: string(),
          content: string(),
          contentSnippet: string(),
          enclosure: object({
            url: string(),
            length: string(),
            type: string(),
          }),
          itunes: object({
            duration: string(),
            image: string(),
            episode: optional(string()),
            season: optional(string()),
          }),
        }),
        transform(({ itunes, ...episode }) => ({
          ...episode,
          ...itunes,
        })),
      ),
    ),
    transform((episodes) => {
      const withCalculatedNumber: Array<NonNullable<typeof episodes>[number] & {
        number: string
      }> = []

      if (episodes) {
        let currentIndex = 0

        for (const episode of episodes.toReversed()) {
          // TODO: We can probably detect missing episodes and adjust episode numbers accordingly, but this will do for now.
          if (episode.season === '1' && episode.episode) {
            currentIndex = Number(episode.episode) + 1
          }
          else {
            withCalculatedNumber.push({
              ...episode,
              number: String(currentIndex++),
            })
          }
        }
      }

      return withCalculatedNumber.toReversed()
    }),
  ),
})

export type PodcastRssFeed = InferOutput<typeof podcastRssFeedSchema>

export type PodcastRssEpisode = NonNullable<PodcastRssFeed['items']>[number]

/**
 * Podcast episodes from Acast include a disclaimer at the end of the description markup.
 * This html-parser plugin removes the disclaimer by locating the first <hr> element and removing it along with all subsequent sibling elements.
 */
export function removeAcastDisclaimer(doc: Document) {
  const hrElement = doc.querySelector('hr')
  if (hrElement) {
    let nextSibling = hrElement.nextSibling
    while (nextSibling) {
      const toRemove = nextSibling
      nextSibling = nextSibling.nextSibling
      toRemove.remove()
    }
    hrElement.remove()
  }

  return doc
}
